"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScanResultItem = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_application_1 = require("@ryerson/frontend.application");

var BarcodeScanResults_1 = require("./BarcodeScanResults");

var ScanResultItem = function ScanResultItem(_ref) {
  var content = _ref.content,
      onContinueClick = _ref.onContinueClick,
      item = _ref.item,
      index = _ref.index;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      primaryBrand = _theme$colors$primary.primaryBrand,
      darkGray = _theme$colors$primary.darkGray,
      secondaryBrand = _theme$colors$primary.secondaryBrand;
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
    css: {
      margin: "15px 0"
    },
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\twidth: 100%;\n\t\t\t\t"]))),
      children: (0, jsx_runtime_1.jsx)(BarcodeScanResults_1.Divider, {
        color: darkGray
      })
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
        size: "md",
        color: secondaryBrand,
        css: {
          marginRight: "5px"
        },
        children: [index + 1, "."]
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
        css: {
          width: "100%"
        },
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "lg",
          color: primaryBrand,
          children: item === null || item === void 0 ? void 0 : item.productFormShape
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          css: {
            marginTop: "5px"
          },
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            variant: "div",
            color: darkGray,
            children: item === null || item === void 0 ? void 0 : item.description
          })
        }), (item === null || item === void 0 ? void 0 : item.partNumber) && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          justifyContent: "flex-end",
          css: {
            marginTop: "16px"
          },
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            color: secondaryBrand,
            children: item === null || item === void 0 ? void 0 : item.partNumber
          })
        }), (item === null || item === void 0 ? void 0 : item.quantityUOM) && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          css: {
            marginTop: "6px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            color: secondaryBrand,
            css: {
              marginRight: "5px"
            },
            children: content.uom
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "md",
            color: secondaryBrand,
            children: (0, frontend_application_1.getDisplayUom)(item.quantityUOM, "quantity")
          })]
        }), (item === null || item === void 0 ? void 0 : item.quantity) && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          css: {
            marginTop: "6px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            color: secondaryBrand,
            css: {
              marginRight: "5px"
            },
            children: content.quantityUOM
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "md",
            color: secondaryBrand,
            children: item === null || item === void 0 ? void 0 : item.quantity
          })]
        }), (item === null || item === void 0 ? void 0 : item.pricingUOM) && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          css: {
            marginTop: "6px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            color: secondaryBrand,
            css: {
              marginRight: "5px"
            },
            children: content.priceUOM
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "md",
            color: secondaryBrand,
            children: (0, frontend_application_1.getDisplayUom)(item.pricingUOM, "price")
          })]
        }), (item === null || item === void 0 ? void 0 : item.customerReferenceNumber) && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          css: {
            marginTop: "6px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            color: secondaryBrand,
            css: {
              marginRight: "5px"
            },
            children: content.customerRef
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "md",
            color: secondaryBrand,
            children: item === null || item === void 0 ? void 0 : item.customerReferenceNumber
          })]
        }), (item === null || item === void 0 ? void 0 : item.altPartNumber) && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          css: {
            marginTop: "6px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            color: secondaryBrand,
            css: {
              marginRight: "5px"
            },
            children: /cpn/i.test(item.altPartNumber) ? content.cpn : content.alt
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "md",
            color: secondaryBrand,
            children: item === null || item === void 0 ? void 0 : item.altPartNumber.replace(/^(cpn|alt):\s*/i, "")
          })]
        }), (item === null || item === void 0 ? void 0 : item.headerPurchaseOrder) && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          css: {
            marginTop: "6px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            color: secondaryBrand,
            css: {
              marginRight: "5px"
            },
            children: content.headerPO
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "md",
            color: secondaryBrand,
            children: item === null || item === void 0 ? void 0 : item.headerPurchaseOrder
          })]
        }), (item === null || item === void 0 ? void 0 : item.linePurchaseOrder) && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          css: {
            marginTop: "6px"
          },
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            weight: "bold",
            size: "md",
            color: secondaryBrand,
            css: {
              marginRight: "5px"
            },
            children: content.linePO
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "md",
            color: secondaryBrand,
            children: item === null || item === void 0 ? void 0 : item.linePurchaseOrder
          })]
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          css: {
            marginTop: "24px"
          },
          children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            label: content.continueButton,
            type: "secondary",
            size: "md",
            onClick: function onClick() {
              return onContinueClick(item);
            },
            paddingType: "relaxed",
            fullwidth: true
          })
        })]
      })]
    })]
  });
};

exports.ScanResultItem = ScanResultItem;